/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface IlsControllerMoveContentToOtherPhase$Params {
  ilsId: string;
  phaseId: string;
  contentId: string;
}

export function ilsControllerMoveContentToOtherPhase(http: HttpClient, rootUrl: string, params: IlsControllerMoveContentToOtherPhase$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerMoveContentToOtherPhase.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('phaseId', params.phaseId, {});
    rb.path('contentId', params.contentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ilsControllerMoveContentToOtherPhase.PATH = '/ils/{ilsId}/{phaseId}/{contentId}/move';
